import { createClient } from '@supabase/supabase-js';
import { authenticatedFunctionHeaders } from './function-headers';

// Create a single supabase client for interacting with your database
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'implicit',
    },
    global: {
      fetch: (
        input: RequestInfo | URL,
        options?: RequestInit & { timeout?: number }
      ) => {
        const opts = options || {};
        opts.timeout = 120000; // 120 seconds
        return fetch(input, opts);
      },
    },
  }
);

export const getEdgeFunctionHeaders = () =>
  authenticatedFunctionHeaders(import.meta.env.VITE_SUPABASE_KEY, () =>
    supabase.auth.getSession()
  );
